/**
 * Affiliate offer banner: finds the discount code the shopper arrived with, fills the banner with the
 * affiliate's name and publishes the offer so the buy box can show the code's extra discount.
 *
 * The offer is kept on window.anomalyAffiliateOffer and announced with an `anomaly:affiliate-offer`
 * event ({ code, name, subPercent, otpPercent, badgeTotal, planId }), so a buy box that initialises later still reads it.
 */
(function () {
  var scriptTag = document.currentScript;
  var sectionId = scriptTag && scriptTag.dataset ? scriptTag.dataset.id : null;
  if (!sectionId) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function parseJSON(el) {
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function readCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    if (!match) return '';
    try { return decodeURIComponent(match[1]); } catch (e) { return match[1]; }
  }

  /** Codes never contain spaces; the length cap keeps a hand-edited URL from flooding the banner. */
  function cleanCode(value) {
    return String(value || '').replace(/\s+/g, '').slice(0, 64);
  }

  /** "CODE | Name" per line, matched case-insensitively. */
  function parseAffiliates(text) {
    var map = {};
    String(text || '').split(/\r?\n/).forEach(function (line) {
      var parts = line.split('|');
      var code = cleanCode(parts[0]).toUpperCase();
      if (code) map[code] = parts.slice(1).join('|').trim();
    });
    return map;
  }

  function fill(template, vars) {
    return String(template || '').replace(/\{(name|code)\}/g, function (match, key) {
      return vars[key] || '';
    });
  }

  function publish(offer) {
    window.anomalyAffiliateOffer = offer;
    document.dispatchEvent(new CustomEvent('anomaly:affiliate-offer', { detail: offer }));
  }

  /** Puts a code from the URL on the cart and in the cookie /discount links set, so checkout applies it. */
  function applyCode(code) {
    document.cookie = 'discount_code=' + encodeURIComponent(code) + '; path=/; SameSite=Lax';
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: code })
    }).catch(function () { /* the cookie alone still carries the code to checkout */ });
  }

  function cartCode() {
    return fetch(root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var codes = (cart && cart.discount_codes) || [];
        return codes.length ? cleanCode(codes[0].code) : '';
      })
      .catch(function () { return ''; });
  }

  function init(section) {
    var cfg = parseJSON(section.querySelector('[data-affiliate-config]'));
    if (!cfg) return;
    var affiliates = parseAffiliates(cfg.affiliates);
    var els = {
      eyebrow: section.querySelector('[data-affiliate-eyebrow]'),
      heading: section.querySelector('[data-affiliate-heading]'),
      text: section.querySelector('[data-affiliate-text]')
    };

    function show(code) {
      var key = code.toUpperCase();
      var listed = Object.prototype.hasOwnProperty.call(affiliates, key);
      if (cfg.listedOnly && !listed) return false;
      var name = listed ? affiliates[key] : '';
      var vars = { name: name, code: key };
      var named = !!name;
      if (els.eyebrow) els.eyebrow.textContent = fill(named ? cfg.eyebrowNamed : cfg.eyebrowCode, vars);
      if (els.heading) els.heading.textContent = fill(named ? cfg.headingNamed : cfg.headingCode, vars);
      if (els.text) els.text.textContent = fill(cfg.text, vars);
      section.hidden = false;
      publish({
        code: key,
        name: name,
        subPercent: Number(cfg.subPercent) || 0,
        otpPercent: Number(cfg.otpPercent) || 0,
        badgeTotal: !!cfg.badgeTotal,
        planId: cfg.planId || ''
      });
      return true;
    }

    var params = new URLSearchParams(window.location.search);
    var urlCode = cleanCode(params.get('code') || params.get('discount'));
    var cookieCode = cleanCode(readCookie('discount_code'));
    var utmCode = (params.get('utm_source') || '').toLowerCase() === 'superfiliate' ? cleanCode(params.get('utm_campaign')) : '';

    // A code from the URL only goes on the cart when the banner accepts it, so the page and checkout agree.
    if (urlCode && show(urlCode)) {
      if (urlCode.toUpperCase() !== cookieCode.toUpperCase()) applyCode(urlCode);
      return;
    }
    if (cookieCode) {
      show(cookieCode);
      return;
    }
    cartCode().then(function (code) {
      if (code && show(code)) return;
      if (utmCode && show(utmCode)) return;
      // Theme editor preview: show the first listed affiliate so the copy can be checked.
      if (window.Shopify && window.Shopify.designMode) {
        var first = Object.keys(affiliates)[0];
        show(first || 'CODE');
      }
    });
  }

  function boot() {
    var section = document.getElementById(sectionId);
    if (section) init(section);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
